var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardPinSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.295 17.8804C22.3721 16.18 23 14.1633 23 12C23 5.92708 18.0729 1 12 1C5.92708 1 1 5.92708 1 12C1 18.0729 5.92708 23 12 23C14.1633 23 16.18 22.3721 17.8804 21.295L23 23L21.295 17.8804Z",
    stroke: "#57486D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PIN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15979 12.886V15H6V9H8.19588C8.61856 9 8.98969 9.08242 9.30928 9.24725C9.63144 9.41209 9.87887 9.64698 10.0515 9.95192C10.2242 10.2541 10.3106 10.5989 10.3106 10.9863C10.3106 11.5742 10.1211 12.0385 9.74227 12.3791C9.36598 12.717 8.84407 12.886 8.17655 12.886H7.15979ZM7.15979 11.8846H8.19588C8.50258 11.8846 8.73582 11.8077 8.89562 11.6538C9.05799 11.5 9.13918 11.2802 9.13918 10.9945C9.13918 10.7005 9.05799 10.4629 8.89562 10.2816C8.73325 10.1003 8.50902 10.0069 8.22294 10.0014H7.15979V11.8846Z",
    fill: "#57486D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3441 15H11.1843V9H12.3441V15Z",
    fill: "#57486D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15H16.8402L14.5825 11.0522V15H13.4227V9H14.5825L16.8441 12.956V9H18V15Z",
    fill: "#57486D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPinSms);
export default __webpack_public_path__ + "static/media/card-pin-sms.be27c96e63cc5af2f05ab4e8571e340f.svg";
export { ForwardRef as ReactComponent };